<button
  class="tool-action"
  [ngClass]="{
    'tool-action--active': widgetType.active,
    'tool-action--position__left': widgetType.docked && toolPosition === 'left',
    'tool-action--position__right': widgetType.docked && toolPosition === 'right',
    'tool-action--position__top': widgetType.docked && toolPosition === 'above',
    'tool-action--position__bottom': widgetType.docked && toolPosition === 'below'
  }"
  (click)="toggle()"
  [matTooltip]="disabled ? '' : (name | translate)"
  [matTooltipPosition]="toolPosition"
>
  <div class="tool-action-icon">
    <div class="container-counter-icon">
      <div class="counter-chip-icon">
        <mat-chip *ngIf="counter > 0" id="counter-chip">
          {{ counter }}
        </mat-chip>
      </div>
      <mat-icon width="1em" height="1em" fontSet="material-icons-outlined" *ngIf="widgetType.hasMaterialIcon()">
        {{widgetType.getIconName()}}
      </mat-icon>
    </div>
    <app-asset-icon width="1em" height="1em" [icon]="widgetType.getIconName()" *ngIf="widgetType.hasAppIcon()">
    </app-asset-icon>
  </div>
  <div [translate]="name" class="tool-action-label">
    {{ widgetType.name }}
  </div>
</button>


